<header
  class="c-card-header header"
  [ngClass]="{
    'header_type_neg': deal?.dealType === 'Negotiated',
    'header_type_comp': deal?.dealType === 'Competitive'
  }"
>
  <div class="header-content">
    <div class="header-content__text">
      <div>
        <span *ngIf="!isModal"
              class="participation">
          <ng-container *ngIf="deal.managementStatus === 'leadManaged'">
            <muni-shared-combo-icon class="icon"></muni-shared-combo-icon>
          </ng-container>
          <ng-container *ngIf="deal.managementStatus === 'coManaged'">
            <i class="icon-simple fa group-follow-star"></i>
          </ng-container>
          <ng-container *ngIf="deal.managementStatus === 'noRole'">
            <i class="icon-simple fa fa-star follow"></i>
          </ng-container>
        </span>
        <span class="header__title deal-size">
          {{ (deal?.size || deal?.amount) | currencyExtended: 'USD':'symbol':'1.0' }}
        </span>
      </div>
      <p class="header__title deal-description">
        {{ title | titlecase }}
      </p>
      <p class="header__subtitle deal-description">
        {{ subtitle | titlecase }}
      </p>
    </div>
    <ng-container *ngIf="!isModal">
      <div *ngIf="deal?.dealType === 'Competitive' && (!isBought() || (!deal?.seniorManager &&
      (!!deal?.saleDate || deal?.isDayToDay || deal?.isTBD))); else tbd">
        <div class="c-text-bold tbd-icon">TBD</div>
      </div>
      <ng-template #tbd>
        <muni-shared-bank-logo
                [orionId]="deal.seniorManager?.orionId"
                size="34"
        ></muni-shared-bank-logo>
      </ng-template>
    </ng-container>
  </div>

  <div *ngIf="!isModal"
          class="c-card-header-menu">
    <i class="fa fa-close close-icon" aria-hidden="true" (click)="removeCard()"></i>
  </div>
</header>
